const brandColors = {
  primary: "#2B96ED",
  primaryPC: "#3c7ae5",
  secondary: "#FF3D3D",
  gray1: "#070E1A",
  gray2: "#4D4D4D",
  gray3: "#8C8C8C",
  gray4: "#D8D8D8",
  gray5: "#EFEFEF",
  gray6: "#a4a4a4",
  gray7: "#7c7c7c",
  gray8: "#E6E6E6",
  gray9: "#F8F8FA",
  gray10: "#949494",
  gray11: "#494949",
  gray12: "#404040",
  gray13: "#fafafa",
  white: "#fff"
};

export default brandColors;
